// extracted by mini-css-extract-plugin
export var crossButton = "styles-module--cross-button--61005";
export var infobar = "styles-module--infobar--60a6d";
export var infobarContainer = "styles-module--infobar-container--0e8bc";